



















import {Component, Vue} from 'vue-property-decorator';

@Component({})
export default class TimeoutModal extends Vue {
  secondsLeft = 10

  mounted() {
    //
  }

  close() {
    this.$store.dispatch('rhizome/closeTimeoutModal')
  }
}
